import React, { Component } from 'react';
import { currencyFormat, numberFormat } from '../helpers/index';

class FactsComponent extends Component {

    simpleItem = (value, name, customPeriod = null) => value && value != '0'
        ? (
            <li key={name}>
                <span className="fact-name">{name}</span>
                <span className="fact-value">{value}{customPeriod}</span>
            </li>
        )
        : null;

    render () {
        const {
            price,
            sqft,
            bedrooms,
            lotSize,
            listingType,
            listingId,
            bathsAll,
            baths,
            halfBath,
            twoThirdBaths,
            quarterBaths,
            garageBays,
            listingStatus,
            floorsAboveGround,
            propertyType,
            listingPricePeriod,
            listingPricePeriodFrom,
            listingPricePeriodTo,
            yearBuilt
        } = this.props.info;

        const isRent = listingType.toLowerCase() === 'for rent' || listingType.toLowerCase() === 'for lease';

        const rent = isRent
            ? 'Rental'
            : '';

        const period = isRent && listingPricePeriod && listingPricePeriod.toLowerCase() !== 'custom'
            ? `/${listingPricePeriod}`
            : '';

        const customPeriod = isRent && listingPricePeriod.toLowerCase() === 'custom'
            ? (
                <span>
                    <span className="custom-period-from">from: {listingPricePeriodFrom}</span>
                    <span className="custom-period-to">till: {listingPricePeriodTo}</span>
                </span>
            )
            : null;

        let priceBlock = null;
        if (price.type === 'value' && price.value) {
            priceBlock = this.simpleItem(`${currencyFormat.format(price.value)}${period}`,
                rent ? rent : 'Price',
                customPeriod
            );
        } else if (price.type === 'range' && price.from && price.to) {
            priceBlock = this.simpleItem(
                `${currencyFormat.format(price.from)} - ${currencyFormat.format(price.to)}${period}`,
                rent ? rent : 'Price',
                customPeriod
            );
        }

        let sqftBlock = null;
        if (sqft.type === 'value' && sqft.value) {
            sqftBlock = this.simpleItem(numberFormat.format(sqft.value), 'Square Feet');
        } else if (sqft.type === 'range' && sqft.from && sqft.to) {
            sqftBlock = this.simpleItem(
                `${numberFormat.format(sqft.from)} - ${numberFormat.format(sqft.to)}`, 'Square Feet');
        }

        const statusBlock = this.simpleItem(listingStatus, 'Status');
        const orderIdBlock = this.simpleItem(this.props.orderId, 'Tour ID')
        const listingIdBlock = this.simpleItem(listingId, 'Listing ID');
        const listingTypeBlock = this.simpleItem(listingType, 'Listing Type');
        const bedroomsBlock = this.simpleItem(bedrooms, 'Bedrooms');
        const totalBathsBlock = this.simpleItem(bathsAll, 'Total Bathrooms');
        const bathsBlock = this.simpleItem(baths, 'Full Bathrooms');
        const halfBathBlock = this.simpleItem(halfBath, 'Half Bathrooms')
        const twoThirdBathsBlock = this.simpleItem(twoThirdBaths, '3/4 Bathrooms')
        const quarterBathsBlock = this.simpleItem(quarterBaths, '1/4 Bathrooms')

        const lotSizeBlock = this.simpleItem(lotSize, 'Lot Size');
        const garageBaysBlock = this.simpleItem(garageBays, 'Garage bays');
        const propertyTypeBlock = this.simpleItem(propertyType, 'Property Type');
        const floorsAboveGroundBlock = this.simpleItem(floorsAboveGround, 'Floors Above Ground');
        const yearBuiltBlock = this.simpleItem(yearBuilt, 'Year Built');

        const factsList = [
            listingIdBlock,
            orderIdBlock,
            listingTypeBlock,
            priceBlock,
            statusBlock,
            bedroomsBlock,
            totalBathsBlock,
            bathsBlock,
            twoThirdBathsBlock,,
            halfBathBlock,
            quarterBathsBlock,
            garageBaysBlock,
            sqftBlock,
            floorsAboveGroundBlock,
            propertyTypeBlock,
            lotSizeBlock,
            yearBuiltBlock
        ];

        return (
            <div className="facts-component">
                <ul>
                    {factsList}
                </ul>
            </div>
        )
    }
}

export default FactsComponent;